import { render, staticRenderFns } from "./ClearDegreesPage.vue?vue&type=template&id=265e8c9e"
import script from "./ClearDegreesPage.vue?vue&type=script&lang=js"
export * from "./ClearDegreesPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports